module.exports = __webpack_public_path__ + "img/Science_et_Avenir.d9d15ae7.svg";